import { useTheme } from "@mui/material";
import {
	getFinancialBalanceTier,
	isPositiveFinancialBalance,
} from "web_myplann/Dashboard/Utils/financialBalanceHealth";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { numberFormatter } from "web_myplann/Shared/Utils/numberFormatters";

const R = Resources.Dashboard.FinancialBalance;

type Params = {
	income: number;
	balance: number;
	currencySign: string;
};

export const useFinancialBalanceHealth = ({
	income,
	balance,
	currencySign,
}: Params) => {
	const theme = useTheme();
	const { t } = useResource();

	const positive = isPositiveFinancialBalance(balance);
	const tier = getFinancialBalanceTier(income, balance);
	const familyColors = theme.palette[tier.family];
	const health = {
		label: t(tier.label),
		bg: familyColors[100],
		color: familyColors[600],
	};

	const tipText = positive
		? t(R.tipPositive, {
				amount: `${numberFormatter.format(balance)} ${currencySign}`,
			})
		: t(R.tipNegative);
	const tipCta = positive ? t(R.tipCtaPositive) : t(R.tipCtaNegative);
	const tipCtaColor = positive
		? theme.palette.blue[600]
		: theme.palette.red[600];

	return { positive, health, tipText, tipCta, tipCtaColor };
};
